import _extends from 'babel-runtime/helpers/extends';

import { parseTime } from '../../../filters/index.js';

export default {
  props: ['id', 'name', 'name_en', 'width', 'height', 'fileSize', 'customStyle', 'useTimes', 'updated_time', 'duration', 'tag_names', 'cat1_name', 'cat2_name'],
  computed: {
    innerStyle: function innerStyle() {
      return _extends({
        maxHeight: '48px',
        minHeight: '48px'
      }, this.customStyle);
    }
  },

  methods: {
    parseTime: parseTime
  }
};